import { PosVendaSlaEstado } from '../../types/posVenda';

export function slaEstadoFromPercentual(percentual: number): PosVendaSlaEstado {
  if (percentual > 100) return 'Vencido';
  if (percentual >= 70) return 'EmRisco';
  return 'NoPrazo';
}

export function slaCor(estado: PosVendaSlaEstado): string {
  switch (estado) {
    case 'Vencido':
    case 'ConcluidoForaDoPrazo':
      return '#e74c3c';
    case 'EmRisco':
      return '#f1c40f';
    case 'ConcluidoNoPrazo':
      return '#27ae60';
    default:
      return '#2ecc71';
  }
}

export function slaRotulo(estado: PosVendaSlaEstado): string {
  switch (estado) {
    case 'Vencido':
      return 'Vencido';
    case 'EmRisco':
      return 'Em risco';
    case 'ConcluidoNoPrazo':
      return 'Concluído no prazo';
    case 'ConcluidoForaDoPrazo':
      return 'Concluído fora do prazo';
    default:
      return 'No prazo';
  }
}
